import { render, staticRenderFns } from "./datawrite.vue?vue&type=template&id=789bd464"
import script from "./datawrite.vue?vue&type=script&lang=js"
export * from "./datawrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports